import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore,
} from 'oidc-client-ts';

const REAL_AUTHORITY =
  process.env.REACT_APP_OIDC_AUTHORITY || 'https://login.webpros.com';

const OIDC_AUDIENCE = process.env.REACT_APP_OIDC_AUD || 'xovi-ai';

const oidcConfig: UserManagerSettings = {
  authority: REAL_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID || '',
  audience: process.env.REACT_APP_OIDC_AUD ?? 'xovi-ai',
  branding: 'riva',
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI || '',
  post_logout_redirect_uri:
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || '',
  response_type: 'code',
  automaticSilentRenew: true,
  scope: 'openid profile email offline_access',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  extraQueryParams: { audience: OIDC_AUDIENCE, branding: 'riva' },
};

export const userManager = new UserManager(oidcConfig);

userManager.events.addSilentRenewError(error => {
  // eslint-disable-next-line no-console
  console.error('OIDC silent renew failed:', error.message);
});
